import { Expose, Transform } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsTalitrixOffenders extends SnModel {
  @Expose({ name: 'participantProfileId' })
  @Transform((value) => value?.toString())
  public id: string;

  @Expose()
  public participantName: string;

  @Expose()
  public priority: string;

  @Expose()
  public offenderType: string;

  @Expose()
  public lastViolation: string;

  @Expose()
  public lastUpdateLocation: any;

  @Expose()
  public bandBatteryLevel: any;

  @Expose()
  public phoneBatteryLevel: string;

  @Expose()
  public createdAt: string;

  @Expose()
  public solution: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
